import { Component, Input, OnInit } from '@angular/core';
import { MasterDataService } from '../masterdata/masterdata.service';
import { LabMDM } from '../masterdata/models/lab';
import { Tags } from '../masterdata/models/tags';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { TagSystem } from '../masterdata/models/tag-system';
import { OperetionHistoryDTO } from '../masterdata/models/operationHistory';
import { SelectableLab } from '../carrier/selectable-lab';

@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.css']
})
export class TagsComponent implements OnInit {
  @Input() masterLists: Tags[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];
  @Input() checkSelectedLab: SelectableLab;
  @Input() tagPlates: string[];
  @Input() loading:boolean;
  
  puid = localStorage.getItem('PUID');
  labOption: LabMDM[] = [];
  selectedMasterList: Tags;
  popupTitle: string;
  displayMasterListDialog: boolean = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  isNewMasterList: boolean;
  masterList: Tags;
  selectedLabName: string;
  selectedLab: LabMDM;
  tagPlateBarcodes: string[];
  tagSystemOptions: any[];
  selectedTagSystem: TagSystem;
  blocked:boolean = false;
  tagPlateNameOldOne:string;
  tagSystemOldOne:string;

  selectableLab = JSON.parse(localStorage.getItem('lab'));
  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) {
  }

  ngOnInit() {
    this.getActiveOptionsForDropdowns();
  }

  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.tagPlateBarcodes = this.masterList.tagPlateBarcode;
    this.tagPlateNameOldOne=this.masterList.tagPlateName;
    this.tagSystemOldOne=this.masterList.tagSystem;
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
  }

  //Retrieve the Active lab for dropdown
  getActiveOptionsForDropdowns() {
    this.labOption=[];

    this.tagSystemOptions=[]
    this._masterDataService.getConfigList(this.selectableLab.lab._id, "tagSystem", 0, 100, true).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.tagSystemOptions = results.data;
        if(this.masterList && this.masterList.tagSystem){
          this.tagSystemOptions.forEach(tag=>{
            if(tag.tagSystemName === this.masterList.tagSystem){
              this.selectedTagSystem = tag;
            }
          });
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );

    this._masterDataService.getLabs(true).subscribe(
      results => {
        if (!results) {
          return;
        }  
         let checkSelectedLabName = this.checkSelectedLab.lab.name;
        this.labOptions = results.data;
        this.labOptions.forEach(lab => {
          
          if(lab.name == checkSelectedLabName) {
            this.labOption.push(lab);
          }
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        })
        this.labOptions= this.labOption;
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );

 }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

  //Insert or update Template
  saveMasterList() {
    let masterLists
    if(!this.masterLists){
      masterLists = []
    }else{
      masterLists = [...this.masterLists]
    }
    if(this.masterList.active && !this.tagPlateBarcodes){
      this._messageService.addErrorMessage({ severity: 'error', summary: 'Plate Barocdes Empty!', detail: 'Active tag plates need a tag plate barcode that can be used.' });
      return;
    }
    if (this.isNewMasterList) {
      if(!this.tagPlates.includes(this.masterList.tagPlateName)){
        this._messageService.addErrorMessage({ severity: 'error', summary: 'Tag Plate Not Found!', detail: 'Tag Plate is not uploaded in Database.' });
        return;
      }
      this.saveMasterData(masterLists);
    }
    else {
      this.updateMasterData(masterLists);
    }
  }
  private handleError(error: any) {
    this.blocked=false;
    let message = this.errorHandler.handleError(error);
    this._messageService.addErrorMessage(message);
  }
  //Inserts a new Template in DB
  saveMasterData(masterLists: any[]) {
    this.masterLists = this.masterLists ? this.masterLists : []
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.tagPlateBarcode = this.tagPlateBarcodes;
    this.masterList.tagSystem = this.selectedTagSystem.tagSystemName;
    this.appendHistory("Tags");
    this.blocked=true;
    this._masterDataService.addTag(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists = [...this.masterLists];
        masterLists.push(results.data);
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
        this._messageService.addSuccessMessage({ severity: 'success', summary: 'Saved Tag Plate!', detail: 'Tag Plate is created.' });
        this.blocked=false;
      },
      error => {
        this.handleError(error);
        }
    );
  }

  //Updates a Template in DB
  updateMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.tagPlateBarcode = this.tagPlateBarcodes;
    this.masterList.tagSystem = this.selectedTagSystem.tagSystemName;
    this.masterList.tagPlateNameold=this.tagPlateNameOldOne;
    this.masterList.tagSystemOldOne=this.tagSystemOldOne;
    this.blocked=true;
    this.appendHistory("Tags");
     this._masterDataService.updateTag(this.masterList).subscribe(
       results => {
         if (!results) {
           return;
         }
         masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
         this.masterLists = masterLists;
         this.displayMasterListDialog = false;
         this._messageService.addSuccessMessage({ severity: 'success', summary: 'Updated Tag Plate!', detail: 'Tag Plate is Updated.' });
         this.masterList.labID=this.selectedLab._id;
        this._masterDataService.saveTagPlates(this.masterList).subscribe(
          result => {
            this.masterList = null;
            this.displayMasterListDialog = false;
            this._messageService.addSuccessMessage({ severity: 'success', summary: 'Saved Tag Plate!', detail: 'Tag Plate is Saved.' });
          },
         error => {
          this.handleError(error);
        }
        );
         this.blocked=false;
       },
       error => {
         this.handleError(error);
         }
     );
  }

  isSaveDisabled() {
    return !(this.masterList && this.masterList.tagPlateName && this.selectedLab && this.masterList.tagSystem)
  }

  appendHistory(tabName: string){
    let historyObj:OperetionHistoryDTO = new OperetionHistoryDTO();
    historyObj.puid = this.puid;
    historyObj.operationDateTime = new Date();
    historyObj.tabName = tabName;
    if(this.masterList.history){
      this.masterList.history.push(historyObj);
    } else {
      this.masterList.history = [];
      this.masterList.history.push(historyObj);
    }
  }
}
